import { useState } from 'react';
import { FiCompass, FiMinus, FiPlus, FiUsers } from 'react-icons/fi';
import { LuSection } from 'react-icons/lu';

import { Link } from 'react-router-dom';
import './ArticleSearchCard.styles.css';
import { useTranslation } from 'react-i18next';

interface Props {
  id: number;
  title: string;
  type: number;
  created: string;
  status: string;
  shortDescription: string;
  key: number;
  confirmed: boolean;
}

const getIcon = ({ type }: { type: number }) => {
  switch (type) {
    case 1: {
      return <LuSection style={{ fontSize: '16px', color: '#98cb00' }} />;
    }
    case 2: {
      return <FiUsers style={{ fontSize: '16px', color: '#98cb00' }} />;
    }
    case 3: {
      return <FiCompass style={{ fontSize: '16px', color: '#98cb00' }} />;
    }
    default: {
      return;
    }
  }
};

export function ArticleSearchCard({
  id,
  title,
  type,
  created,
  status,
  confirmed,
  shortDescription,
}: Props) {
  const { t } = useTranslation();
  const REG_TYPE_MAP: { 1: string; 2: string; 3: string } = {
    1: t('common.specification'),
    2: t('common.company-agreement'),
    3: t('common.implementation'),
  };
  const [expanded, setExpanded] = useState(false);
  const handleExpand = () => {
    setExpanded(!expanded);
  };
  return (
    <div className="article-search-card-container">
      <div className="article-search-card-expand">
        {expanded ? (
          <FiMinus
            style={{ fontSize: '16px', color: '#98cb00', cursor: 'pointer' }}
            onClick={handleExpand}
          />
        ) : (
          <FiPlus
            style={{ fontSize: '16px', color: '#98cb00', cursor: 'pointer' }}
            onClick={handleExpand}
          />
        )}
      </div>
      <div className="article-search-card">
        <div className="article-search-card-header">
          <Link to={`/regulation/${id}`}>
            <div className="title">{title}</div>
          </Link>
        </div>
        <div className="footer">
          <div className="type-container">
            <div className="type">
              {getIcon({ type })}
              {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
              {/* @ts-expect-error*/}
              {REG_TYPE_MAP[type]}
            </div>
          </div>
          {expanded && (
            <div className="description">
              {shortDescription ? (
                <span dangerouslySetInnerHTML={{ __html: shortDescription || '' }} />
              ) : (
                t('common.no-description')
              )}
            </div>
          )}
        </div>
      </div>
      <div className="article-search-card-info">
        <div>
          {t('common.status')}: {status}
        </div>
        <div>
          {t('common.created')}: {created}
        </div>
        <div>
          {t('common.confirmed')}: {confirmed ? t('common.yes') : t('common.no')}
        </div>
      </div>
    </div>
  );
}
